import React from 'react';
import TransactionsTable from './TransactionsTable';
import { getUserData } from '../auth';

const TransactionsTableFalse = () => {

  const userData = getUserData();
  const userId = userData?.uid || "";
    const isActive = false; // Replace with dynamic filter

  return (
    <div>
      <h4>My Transactions </h4>
      <TransactionsTable userId={userId} isActive={isActive} />
    </div>
  );
};

export default TransactionsTableFalse;